import { useState } from 'react';
import { Alert, Collapse } from '@mui/material';
import { useModalProvider } from './ModalContext';
import useDebouncer from '../../Hooks/useDebounce';

import styles from './ApplicationModal.module.css';

/**
 * Modal Component that renders MUI Alerts queued from the ModalContentContext
 */
export default function ModalAnnouncementCenter() {
	const modalContext = useModalProvider();
	const { modalAnnouncements, removeModalAnnouncement } = modalContext;
	const announcement = modalAnnouncements.length > 0 ? modalContext.modalAnnouncements[0] : undefined;
	const [isOpen, setIsOpen] = useState(true);

	useDebouncer(
		() => {
			if (!isOpen && announcement) {
				// When the announcement closes, let the animation complete and remove
				removeModalAnnouncement(announcement.id);
				// Set back to open for the next announcement
				setIsOpen(true);
			}
		},
		[isOpen, announcement, removeModalAnnouncement],
		200
	);

	if (!announcement) {
		return <></>;
	}

	return (
		<Collapse
			in={isOpen}
			appear={true}
		>
			<Alert
				elevation={0}
				severity={announcement.severity}
				onClose={() => {
					setIsOpen(false);
				}}
				className={styles.alert}
			>
				{announcement.message}
			</Alert>
		</Collapse>
	);
}
